import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import store from '../store';

import HomepageNewest from '../components/homepage/HomepageNewest';

let isLogged = null;

const layoutLogin = document.getElementsByClassName('layout-login');
if (layoutLogin) {
    isLogged = layoutLogin.length > 0;
}

const homepageNewest = document.getElementById('homepage-newest');
if (homepageNewest) {
    createRoot(homepageNewest).render(
        <Provider store={store}>
            <HomepageNewest isLogged={isLogged} />
        </Provider>
    );
}
